module.exports = __webpack_public_path__ + "img/setting.6d316601.svg";